import { render, staticRenderFns } from "./CallSet.vue?vue&type=template&id=22c4e8a8&scoped=true"
import script from "./CallSet.vue?vue&type=script&lang=js"
export * from "./CallSet.vue?vue&type=script&lang=js"
import style0 from "./CallSet.vue?vue&type=style&index=0&id=22c4e8a8&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c4e8a8",
  null
  
)

export default component.exports